import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import companySignin from "./services";
import StatusNavigator from "../../navigator";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import { useRecoilState } from "recoil";
import { loggedInUser } from "../../atom/globalState";
import { jwtDecode } from "jwt-decode";

const CompanyLogin = () => {
  const [currentUser, setLoggedInUser] = useRecoilState(loggedInUser);
  const location = useLocation();
  const navigate = useNavigate();
  const [load, setLoad] = useState();
  const [validated, setValidated] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const dataJson = {
    email: "",
    password: "",
  };

  const [data, setData] = useState(dataJson);

  const setValue = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const loadCurrentUser = () => {
    debugger;
    const token = localStorage.getItem("token");
    if (token) {
      const decodedToken = jwtDecode(token);
      setLoggedInUser(decodedToken);
      console.log("loggedIn_user_data", loggedInUser);
    } else {
      setMessage("Token not Found");
      setSeverity("error");
      setOpen(true);
    }
  };

  const signIn = () => {
    setLoad(true);
    companySignin
      .signIn(data)
      .then((respons) => {
        debugger;
        localStorage.setItem("token", respons.data.data.token);
        if (localStorage.getItem("token")) {
          navigate("/dashboard/company/home", {
            state: { pathLink: location.pathname },
          });
        }
        loadCurrentUser();
        setLoad(false);
      })
      .catch((e) => {
        debugger;
        console.log(e.message);

        if (e.response) {
          if (e.response.status === 401) {
            console.log("Unauthorized access:", e.response.data.message);
            setMessage(e.response.data.message);
            setSeverity("error");
            setOpen(true);
          } else if (e.response.status === 500) {
            setMessage(e.response.data.message);
            setSeverity("error");
            setOpen(false);
          } else {
            console.log("Unexpected error occurred:", e.response.status);
            setMessage("Something went wrong");
            setSeverity("error");
            setOpen(true);
          }
        } else {
          setMessage("Something went wrong");
          setSeverity("error");
          setOpen(true);
        }

        setLoad(false);
      });
  };

  const handleSubmit = (event) => {
    debugger;
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (data.email !== "" && data.password !== "") {
        signIn();
      }
    }
    setValidated(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  useEffect(() => {
    debugger;
    if (localStorage.getItem("token")) {
      navigate("/dashboard/company/home");
    }
    if (location.state !== null) {
      if (location.state.resetPassword) {
        setOpen(location.state.resetPassword);
        setMessage(location.state.message);
        //  setSeverity("success");

        // Swal.fire({
        //   // position: "top-end",
        //   icon: "success",
        //   title: "New Account has been Created",
        //   showConfirmButton: false,
        //   timer: 1500,
        // });
      }
    }
  }, []);
  return (
    <>
      <StatusNavigator />
      <div className="wrapper">
        <main className="authentication-content">
          <div className="container">
            <div className="authentication-card">
              <div className="card shadow rounded-0 overflow-hidden w-100  mt-3">
                <div className="row g-0">
                  <div className="col-lg-6 bg-login align-items-center justify-content-center">
                    <div className="px-4 px-lg-5 text-center">
                      <img
                        className="me-2 mb-3 mt-lg-5 pt-lg-5"
                        src="assets/images/login-img.png"
                        alt="login-img"
                      />
                      <p className="mb-lg-5 mt-lg-5">
                        Your all-in-one solution designed to streamline
                        registration processes, enhance workflow visibility, and
                        drive productivity across a wide range of industries
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card-body p-4 p-sm-5">
                      <div className="text-center">
                        <img
                          className="me-2 mb-3"
                          src="assets/images/tapme-icon.svg"
                          width="66"
                          alt=""
                        />
                        <h3 className="card-title mb-3">
                          Log in to your account
                        </h3>
                        <p className="text-blue font-14 mb-4">
                          Login with credentials shared by
                          <br />
                          your organization.
                        </p>
                      </div>
                      <Form
                        className="form-body pt-2"
                        noValidate
                        validated={validated}
                      >
                        <div className="row g-3">
                          <div className="col-12">
                            <Form.Group
                              controlId="validationCustom01"
                              className="ms-auto position-relative"
                            >
                              <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="17"
                                  viewBox="0 0 20 17"
                                  fill="none"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M7.96912 2.94814e-07H11.7392C13.4238 -1.42388e-05 14.7582 -2.58163e-05 15.8024 0.140374C16.8772 0.284866 17.747 0.589307 18.433 1.27531C19.119 1.96131 19.4235 2.83118 19.568 3.9059C19.7084 4.95018 19.7083 6.28451 19.7083 7.96912V8.07254C19.7083 9.75716 19.7084 11.0915 19.568 12.1358C19.4235 13.2105 19.119 14.0804 18.433 14.7664C17.747 15.4524 16.8772 15.7568 15.8024 15.9013C14.7582 16.0417 13.4238 16.0417 11.7392 16.0417H7.96912C6.28451 16.0417 4.95018 16.0417 3.9059 15.9013C2.83118 15.7568 1.96131 15.4524 1.27531 14.7664C0.589307 14.0804 0.284866 13.2105 0.140374 12.1358C-2.58163e-05 11.0915 -1.42388e-05 9.75716 2.94814e-07 8.07255V7.96912C-1.42388e-05 6.2845 -2.58163e-05 4.95018 0.140374 3.9059C0.284866 2.83118 0.589307 1.96131 1.27531 1.27531C1.96131 0.589307 2.83118 0.284866 3.9059 0.140374C4.95018 -2.58163e-05 6.28451 -1.42388e-05 7.96912 2.94814e-07ZM4.08911 1.50311C3.16686 1.62711 2.63552 1.85964 2.24758 2.24758C1.85964 2.63552 1.62711 3.16686 1.50311 4.08911C1.37646 5.03114 1.375 6.27292 1.375 8.02083C1.375 9.76875 1.37646 11.0105 1.50311 11.9526C1.62711 12.8748 1.85964 13.4061 2.24758 13.7941C2.63552 14.182 3.16686 14.4146 4.08911 14.5386C5.03114 14.6652 6.27291 14.6667 8.02083 14.6667H11.6875C13.4354 14.6667 14.6772 14.6652 15.6192 14.5386C16.5415 14.4146 17.0728 14.182 17.4608 13.7941C17.8487 13.4061 18.0812 12.8748 18.2052 11.9526C18.3319 11.0105 18.3333 9.76875 18.3333 8.02083C18.3333 6.27292 18.3319 5.03114 18.2052 4.08911C18.0812 3.16686 17.8487 2.63552 17.4608 2.24758C17.0728 1.85964 16.5415 1.62711 15.6192 1.50311C14.6772 1.37646 13.4354 1.375 11.6875 1.375H8.02083C6.27292 1.375 5.03114 1.37646 4.08911 1.50311ZM3.82602 3.91404C4.06909 3.62235 4.5026 3.58294 4.79429 3.82601L6.77328 5.47517C7.62849 6.18785 8.22225 6.68105 8.72353 7.00345C9.20878 7.31554 9.53785 7.4203 9.85417 7.4203C10.1705 7.4203 10.4996 7.31554 10.9848 7.00345C11.4861 6.68105 12.0798 6.18785 12.9351 5.47517L14.914 3.82601C15.2057 3.58294 15.6392 3.62235 15.8823 3.91404C16.1254 4.20573 16.086 4.63924 15.7943 4.88232L13.7808 6.56019C12.9684 7.23729 12.3098 7.7861 11.7286 8.15991C11.1231 8.54932 10.5335 8.7953 9.85417 8.7953C9.17485 8.7953 8.5852 8.54932 7.97975 8.15991C7.39853 7.7861 6.73999 7.2373 5.9275 6.5602L3.91404 4.88232C3.62235 4.63924 3.58294 4.20573 3.82602 3.91404Z"
                                    fill="#1E73FF"
                                  />
                                </svg>
                              </div>
                              <Form.Control
                                className="form-control radius-4 ps-5 height-50"
                                required
                                type="email"
                                placeholder="Email Address"
                                name="email"
                                onChange={setValue}
                                pattern=".+@[^@\s]+\.[^.\s]+"
                              />
                              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                            </Form.Group>
                          </div>
                          <div className="col-12">
                            <Form.Group
                              controlId="validationCustom02"
                              className="ms-auto position-relative"
                            >
                              <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M6 22C5.45 22 4.979 21.804 4.587 21.412C4.195 21.02 3.99934 20.5493 4 20V10C4 9.45 4.196 8.979 4.588 8.587C4.98 8.195 5.45067 7.99933 6 8H7V6C7 4.61667 7.48767 3.43733 8.463 2.462C9.43834 1.48667 10.6173 0.999334 12 1C13.3833 1 14.5627 1.48767 15.538 2.463C16.5133 3.43833 17.0007 4.61733 17 6V8H18C18.55 8 19.021 8.196 19.413 8.588C19.805 8.98 20.0007 9.45067 20 10V20C20 20.55 19.804 21.021 19.412 21.413C19.02 21.805 18.5493 22.0007 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.021 16.804 13.413 16.412C13.805 16.02 14.0007 15.5493 14 15C14 14.45 13.804 13.979 13.412 13.587C13.02 13.195 12.5493 12.9993 12 13C11.45 13 10.979 13.196 10.587 13.588C10.195 13.98 9.99934 14.4507 10 15C10 15.55 10.196 16.021 10.588 16.413C10.98 16.805 11.4507 17.0007 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z"
                                    fill="#1E73FF"
                                  />
                                </svg>
                              </div>
                              <Form.Control
                                className="form-control radius-4 ps-5 height-50"
                                required
                                type="password"
                                placeholder="Enter Password"
                                name="password"
                                onChange={setValue}
                              />
                              <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
                            </Form.Group>
                            <Link
                              style={{
                                textAlign: "right",
                                display: "block",
                                marginTop: "10px",
                              }}
                              to="/forgetPassword"
                              state={{ path: "/login" }}
                            >
                              Forgot Password
                            </Link>
                          </div>
                        </div>
                      </Form>

                      <div className="col-12 mt-5">
                        <div className="d-grid">
                          {load ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <CircularProgress />
                            </div>
                          ) : (
                            <button
                              to="/dashboard/admin/home"
                              type="submit"
                              className="btn btn-primary login-btn height-50"
                              onClick={handleSubmit}
                            >
                              Sign In
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="login-separater text-center mb-4">
                        {" "}
                        {/* <span>or Login with</span>
                        <hr /> */}
                      </div>
                      {/* <div className="text-center">
                        <a
                          className="btn btn-white radius-30 height-50 text-center width-50 text-center me-3"
                          href="javascript:;"
                        >
                          <span className="d-flex justify-content-center align-items-center">
                            <img
                              className="me-0"
                              src="assets/images/icons/search.svg"
                              width="22"
                              alt=""
                            />
                          </span>
                        </a>

                        <a
                          className="btn btn-white radius-30 height-50 text-center width-50"
                          href="javascript:;"
                        >
                          <span className="d-flex justify-content-center align-items-center">
                            <img
                              className=""
                              src="assets/images/logos_facebook.svg"
                              width="24"
                              alt=""
                            />
                          </span>
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
};

export default CompanyLogin;
